// extracted by mini-css-extract-plugin
export var chatHtmlText = "_qp-2";
export var chatLink = "_qp-0";
export var chatText = "_qp-1";